export default __webpack_public_path__ + "static/media/UploadIcon.087f2300.svg";